import { createStore } from 'redux'

const initialState = {
   isLoggedIn: false,
   username: '', 
   accessToken: '',
   email: '',
   userId: 0,
}

const reducer = (state = initialState, action) => {
    switch(action.type){
        case 'IS_LOGGED_IN':
            return Object.assign({}, state, {
                isLoggedIn: true,
                username: action.username,
                accessToken: action.accessToken,
                email: action.email,
                userId: action.userId
            });
    }

    return state
}

const store = createStore(
    reducer, 
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)

export default store